<div data-cy="borrower-schedule-dropdown">
  <mat-grid-list cols="2" rowHeight="25px">
    <mat-grid-tile [colspan]="1">
      <h3 class="reminder-header">Set a Reminder</h3>
    </mat-grid-tile>
    <mat-grid-tile [colspan]="1">
      <h4 class="day-of-week">{{ viewDate | date: 'longDate' }}</h4>
    </mat-grid-tile>
  </mat-grid-list>
  <mat-grid-list cols="2" rowHeight="450px">
    <mat-grid-tile [colspan]="1">
      <div class="reminder-form-tile">
        <app-schedule-reminder-form
          [startDate]="(selectedDateSubject$ | async)"
          (newReminder)="emitNewReminder($event)"
          (cancel)="emitCancelReminder()"
          (newDateSelected)="setSelectedDate($event)"></app-schedule-reminder-form>
      </div>
    </mat-grid-tile>
    <mat-grid-tile [colspan]="1">
      <div class="day-view">
        <mwl-calendar-day-view
          [viewDate]="viewDate"
          [events]="events"
          [refresh]="refresh"
          [dayStartHour]="6"
          [dayEndHour]="21"
          (hourSegmentClicked)="hourSegmentClicked($event)"
        ></mwl-calendar-day-view>
      </div>
    </mat-grid-tile>
  </mat-grid-list>
</div>

